jQuery(document).ready(function ($) {
  //Blade Type Selection
  $(".blade-type-selector li").click(function () {
    var updateBladeType = $(this).attr("data-blade-type");
    var updateBladeText = $(this).attr("data-blade-text");

    $(".blade-type-selector  p .filter-blade-type ").text(updateBladeText);
    $(".filter-blade-type").attr("data-value", updateBladeType);
    $(".blade-type-selector .filter-item").removeClass("active");

    /* check if size 60 is selected, if selected, pre-select 46 */
    if (updateBladeType == "wing-tip" || updateBladeType == "leaf") {
      defaultBladeSize();
    }

    updateCurrentMainListing();
  });

  //Blade Count Selection
  $(".blade-count-selector li").click(function () {
    var updateBladeCount = $(this).attr("data-blade-count");
    var updateCountText = $(this).attr("data-count-text");
    $(".filter-blade-count").attr("data-value", updateBladeCount);
    $(".blade-count-selector .filter-item").removeClass("active");
    $(".blade-count-selector p .filter-blade-count").text(updateCountText);
    updateCurrentMainListing();
  });

  //Motor Type Selection
  $(".motor-type-selector li").click(function () {
    var updateMotorType = $(this).attr("data-motor-type");
    $(".filter-motor-type").attr("data-value", updateMotorType);
    $(".motor-type-selector .filter-item").removeClass("active");
    $(".motor-type-selector  p .filter-motor-type ").text(updateMotorType);

    /* check if size 60 is selected, if selected, pre-select 46 */
    if (updateMotorType == "hugger") {
      defaultBladeSize();
    }

    updateCurrentMainListing();
  });

  //Fan Type Selection
  $(".fan-type-selector li").click(function () {
    var currentMotor = $(".current-sub-listing .filter-motor-color").attr(
      "data-value",
    );
    var updateFanType = $(this).attr("data-fan-type");
    var updateFanImage = $(this).attr("data-fan-image");
    $(".filter-fan-type").attr("data-value", updateFanType);
    $(".fan-type-selector .filter-item").removeClass("active");
    $(".fan-type-selector  p .filter-fan-type ").text(updateFanType);
    $(".image-overlays .fan-img").attr("src", updateFanImage);
    updateCurrentMainListing();
  });

  //Light Type Selection
  $(".light-type-selector li").click(function () {
    var updateLightType = $(this).attr("data-light-type");
    if (updateLightType == "nrgb") {
      //remove this if-else code if ncct / cct is enabled
      $(".filter-light-type").attr("data-value", updateLightType);
      $(".light-type-selector .filter-item").removeClass("active");
      $(".light-type-selector p .filter-light-type ").text(
        updateLightType.replace("n", ""),
      );
      updateCurrentMainListing();
    }
  });

  //Blade Size Selection
  $(".blade-size-selector li").click(function () {
    var updateBladeSize = $(this).attr("data-blade-size");
    $(".filter-blade-size").attr("data-value", updateBladeSize);
    $(".blade-size-selector .filter-item").removeClass("active");
    $(".blade-size-selector p .filter-blade-size").text(updateBladeSize + '"');
    updateCurrentMainListing();
  });

  //Motor Color Selection
  $(".motor-color-selector li").click(function () {
    var updateMotorColor = $(this).attr("data-motor-color");
    var updateMotorColorText = $(this)
      .attr("data-color-text")
      .replace(" motor", "");
    var updateMotorColorRestock = $(this).attr("data-restock");
    var updateStockNumber = $(this).attr("data-stockIndicator");

    //var updateMotorImage = $(this).attr("data-motor-image");
    $(".filter-motor-color").attr("data-value", updateMotorColor);
    $(".motor-color-selector p .filter-motor-color").text(updateMotorColorText);
    $(".motor-color-selector .filter-item").removeClass("active");

    //$('.image-overlays .motor-img').attr('src', updateMotorImage);
    if (updateMotorColorRestock != "") {
      $(".product-restocks").attr("data-restock-nval", updateMotorColorRestock);
    } else {
      console.log("this is removed");
      $(".product-restocks").attr("data-restock-nval", "");
    }
    $("#currentSelection").attr("data-stockNum", updateStockNumber);
    updateStockIndicator();
    updateCurrentMainListing();
  });

  //Blade Color Selection
  $(".blade-color-selector li").click(function () {
    var updateBladeColor = $(this).attr("data-blade-color");
    var updateBladeColorText = $(this)
      .attr("data-color-text")
      .replace(" blade", "");
    //var updateBladeImage = $(this).attr("data-blade-image");
    $(".filter-blade-color").attr("data-value", updateBladeColor);
    $(".blade-color-selector p .filter-blade-color").text(updateBladeColorText);
    $(".blade-color-selector .filter-item").removeClass("active");
    //$('.image-overlays .blade-img').attr('src', updateBladeImage);
    updateCurrentMainListing();
  });

  updateCurrentMainListing();
  initialImages();
});
var wasCurveActive = false;
function updateCurrentMainListing() {
  //console.log("oasis pro updates");

  /* get current listing values */
  var currentBladeType = $(".current-main-listing .filter-blade-type").attr(
    "data-value",
  );
  var currentBladeCount = $(".current-main-listing .filter-blade-count").attr(
    "data-value",
  );
  var currentMotorType = $(".current-main-listing .filter-motor-type").attr(
    "data-value",
  );
  var currentFanType = $(".current-main-listing .filter-fan-type").attr(
    "data-value",
  );
  var currentLightType = $(".current-main-listing .filter-light-type").attr(
    "data-value",
  );
  var currentBladeSize = $(".current-sub-listing .filter-blade-size").attr(
    "data-value",
  );
  var currentBladeColor = $(".current-sub-listing .filter-blade-color").attr(
    "data-value",
  );
  var currentMotorColor = $(".current-sub-listing .filter-motor-color").attr(
    "data-value",
  );
  var productRestockMain = $(".current-sub-listing .filter-motor-color").attr(
    "data-restock",
  );
  var productRestockNumb = $(".current-sub-listing .filter-motor-color").attr(
    "data-stockIndicator",
  );

  $(".product-restocks .manual-delivery-disclaimer").remove();
  $(".product-restocks .timerBox").show();

  /* manual set of hide/show sold out for oasis pro
  // 
  if (currentMotorType == "downrod"){
    console.log('downrod');
    if( currentBladeSize == "60" &&
        currentBladeCount == "5-blades"
    ){
      $(".product-restocks").html("");
      $('.stock-indicator').removeClass('active');
      //$('.filter-item.dark-wood-blade').hide();
      $('.filter-item.dark-wood-blade').addClass('disabled');
      console.log('hide dark wood');
      //if current selected is dark wood, set all to use defaults
      if(currentBladeColor == 'dark-wood-blade'){
        setTimeout(function() {
            $('.filter-item.matte-black-blade').click();
        }, 1000);
        
      }
    }else{
      //$('.filter-item.dark-wood-blade').show();
      $('.filter-item.dark-wood-blade').removeClass('disabled');
    }
    if(
      currentFanType == "standard" 
    ){
      $(".product-restocks").html("");
      $('.stock-indicator').removeClass('active');
      //$('.filter-item.light-wood-motor').hide();
      $('.filter-item.light-wood-motor').addClass('disabled');
      console.log('hide light wood motor');
      //if current selected is light wood, set all to use defaults
      if(currentMotorColor == 'light-wood-motor'){
        console.log('current is light wood');
        setTimeout(function() {
            $('.filter-item.matte-black-motor').click();
        }, 1000);
        
      }
    }else{
      $('.filter-item.light-wood-motor').show();
      $('.filter-item.light-wood-motor').removeClass('disabled');
    }
  }else{
    $('.stock-indicator').removeClass('active');
    $('.stock-indicator.text-success').addClass('active');
    //$('.filter-item.dark-wood-blade').show();
    //$('.filter-item.light-wood-motor').show();
    $('.filter-item.dark-wood-blade').removeClass('disabled');
    $('.filter-item.light-wood-motor').removeClass('disabled');
  }

  /* end of manual set */

  /* manual set of oos for oasis pro macaron */
  /* ============================================================
   MANUAL RESTRICTION
   Curve blade only:
   Cannoli Cream / 46" / 3-Blade
============================================================ */

  /* determine curve state via data-value */
  var isCurveActive = currentBladeType === "curve";

  /* ------------------------------------------
   Detect re-entering Curved
------------------------------------------- */
  if (isCurveActive && !wasCurveActive) {
  var $currentBlade = $(".filter-item." + currentBladeCount);

  // only force default if current selection is disabled
  if ($currentBlade.hasClass("disabled")) {
    setTimeout(function () {
      $(".filter-item.5-blades").click();
    }, 300);
  }
}


  /* update previous state */
  wasCurveActive = isCurveActive;

  /* reset always */
  $(".filter-item.bsize46").removeClass("disabled");
  $(".filter-item.3-blades").removeClass("disabled");
  $(".filter-item.cannoli-cream-blade").removeClass("disabled");

  /* apply rules ONLY when curve is active */
  if (isCurveActive) {
    /* Cannoli + 46" → disable 3-Blade */
    if (
      currentBladeColor === "cannoli-cream-blade" &&
      currentBladeSize === "46"
    ) {
      $(".filter-item.3-blades").addClass("disabled");

      if (currentBladeCount === "3-blades") {
        setTimeout(function () {
          $(".filter-item.5-blades").click();
        }, 300);
      }
    }

    /* 46" + 3-Blade → disable Cannoli */
    if (currentBladeSize === "46" && currentBladeCount === "3-blades") {
      $(".filter-item.cannoli-cream-blade").addClass("disabled");

      if (currentBladeColor === "cannoli-cream-blade") {
        setTimeout(function () {
          $(".filter-item.matte-black-blade").click();
        }, 300);
      }
    }

    /* Cannoli + 3-Blade → disable 46" */
    if (
      currentBladeColor === "cannoli-cream-blade" &&
      currentBladeCount === "3-blades"
    ) {
      $(".filter-item.bsize46").addClass("disabled");

      if (currentBladeSize === "46") {
        setTimeout(function () {
          $(".filter-item.bsize52").click();
        }, 300);
      }
    }
  }

  /* end of manual set for macaron

  /* set the values as handles - to compare and be used for the classes */
  var currentMainHandle =
    currentBladeType +
    "-" +
    currentBladeCount +
    "-" +
    currentMotorType +
    "-" +
    currentFanType +
    "-" +
    currentLightType;
  var currentMainVariant =
    currentBladeSize + "-" + currentMotorColor + "-" + currentBladeColor;

  // add 'd' to curve. For display purposes. take note of this as it gets confusing have curve as the selector and curved as the display
  if (currentBladeType == "curve") {
    $(".blade-type-selector  p .filter-blade-type ").text(
      currentBladeType + "d",
    );
  }

  // display rgb + cct if rgb is selected
  if (currentLightType == "nrgb") {
    $(".light-type-selector  p .filter-light-type ").text("RGB + CCT");
  }
  /* set the boxes to active */
  $(".blade-type-selector .filter-item." + currentBladeType).addClass("active");
  $(".blade-count-selector .filter-item." + currentBladeCount).addClass(
    "active",
  );
  $(".motor-type-selector .filter-item." + currentMotorType).addClass("active");
  $(".fan-type-selector .filter-item." + currentFanType).addClass("active");
  $(".light-type-selector .filter-item." + currentLightType).addClass("active");
  $(".blade-size-selector .filter-item.bsize" + currentBladeSize).addClass(
    "active",
  );
  $(".blade-color-selector .filter-item." + currentBladeColor).addClass(
    "active",
  );
  $(".motor-color-selector .filter-item." + currentMotorColor).addClass(
    "active",
  );

  /* display the 60 size selection only for downrod curved */
  if (currentMotorType == "downrod") {
    if (currentBladeType == "curve") {
      $(".filter-item.bsize60").addClass("enabled");
    } else {
      $(".filter-item.bsize60").removeClass("enabled active");
    }
  } else {
    $(".filter-item.bsize60").removeClass("enabled active");
  }
  /* set standard white or black image based on motor color */
  if (currentFanType == "standard") {
    if (
      currentMotorColor == "matte-black-motor" ||
      currentMotorColor == "dark-wood-motor"
    ) {
      var updateFanImage = $(".filter-item.standard.active").attr(
        "data-fan-image-black",
      );
    } else {
      var updateFanImage = $(".filter-item.standard.active").attr(
        "data-fan-image",
      );
    }
    $(".image-overlays .fan-img").attr("src", updateFanImage);
  }

  /* handle - url information */
  $(".current-main-listing-handle").text(currentMainHandle);
  $(".current-variant-listing-handle").text(currentMainVariant);

  var fullHandle = currentMainHandle + "-" + currentMainVariant;
  $(".current-full-handle").text(fullHandle);

  $(".indiv-prod").removeClass("active");
  $(".indiv-prod .variant-item").removeClass("active");
  $("#" + currentMainHandle).addClass("active");
  $("#" + fullHandle).addClass("active");

  /* ----------
    variant id - handling of information
  ----------- */
  var cartID = $("#" + fullHandle).attr("data-variant");
  var variantImage = $("#" + fullHandle).attr("data-image");
  console.log(variantImage);
  var varPrice = $("#" + fullHandle).attr("data-price");
  var varCompare = $("#" + fullHandle).attr("data-compare");
  var varPercent = $("#" + fullHandle).attr("data-compare-percentage");
  var getGrab = $(".payment-alt-options .grab-info").attr("data-discount");

  var getAtome = $(".payment-alt-options .atome-info").attr("data-discount");

  var varVoucher = $("#" + fullHandle).attr("data-oasisVoucher");
  var updateVoucher = varPrice - varVoucher;

  if (varVoucher != "") {
    // if there is voucher, use voucher price to calculate grab/atome
    var initialAtome = updateVoucher / getAtome;
    var initialGrab = updateVoucher / getGrab;
  } else {
    var initialAtome = varPrice / getAtome;
    var initialGrab = varPrice / getGrab;
  }
  //console.log('variant ID:' +cartID);

  //update pricing, grab and atome from variant selected
  $("span#ProductPrice-product-template").text(
    "$" + varPrice.replace(".00", ""),
  );
  $("s#ComparePrice-product-template").text(
    "$" + varCompare.replace(".00", ""),
  );
  $("span#compare_precntage, .comparetooltip").text(varPercent);
  $(".payment-alt-options .grab-info.price-value").text(Math.ceil(initialGrab));
  $(".payment-alt-options .atome-info.price-value").text(
    Math.ceil(initialAtome),
  );
  $(".voucher-pricing .voucher-wrap span#voucher-price").text(
    "$" + updateVoucher,
  );
  // update climate voucher price
  $(".voucher-pricing .tooltip .voucher-wrap .voucher-price").html(
    `$${Math.max(updateVoucher - window.cv_price, 0).toLocaleString()}`,
  );
  $(".product-form__cart span.voucher1").text("$" + updateVoucher);
  $("a#initateCheckout .voucher").text("$" + updateVoucher);

  //update variant image (smart or standard) displayed
  $(".image-overlays .blade-img").attr("src", variantImage);
  $(".image-overlays .blade-img").attr("data-src", variantImage);

  //add variant to cart link
  $("#currentSelection").attr("data-variant", cartID);
  $("#currentSelection").text(cartID);

  // update #currentSelection attributes
  $("#currentSelection").attr("data-price", varPrice);
  $("#currentSelection").attr("data-compare", varCompare);
  $("#currentSelection").attr("data-voucher", varVoucher);

  //update restock
  var currentToUpdateRestock = $(".product-restocks").attr("data-restock-nval");
  var varMainRestock = $("#" + fullHandle).attr("data-restock");
  console.log("wata" + currentToUpdateRestock);
  if (currentToUpdateRestock != "") {
    //console.log('update1');
    $(".product-restocks").html(
      "<p class='text-center'>" + currentToUpdateRestock + "</p>",
    );
  } else {
    //console.log("wata2"+varMainRestock);
    if (varMainRestock == "") {
      $(".product-restocks").html(
        "<p class='text-center'>Delivers in 5-10 Working Days</p>",
      );
    } else {
      $(".product-restocks").html(
        "<p class='text-center'>" + varMainRestock + "</p>",
      );
      //console.log('blade-type'+currentBladeType);

      //console.log('regular');
      $(".product-restocks").html(
        "<p class='text-center'>" + varMainRestock + "</p>",
      );
      $(".stock-indicator").removeClass("active");
      $(".stock-indicator.text-success").addClass("active");
    }
  }
  //console.log(cartID);
  if (cartID == undefined) {
    $("#AddToCart-button").addClass("disabled");
  } else {
    $("#AddToCart-button").removeClass("disabled");
  }
  $("#AddToCart-button").attr(
    "href",
    "/cart/add?id[]=" + cartID + "&quantity=1",
  );
}

function defaultBladeSize() {
  /* check if size 60 is selected, if selected, pre-select 46 */
  var getBladeSize = $(".current-sub-listing .filter-blade-size").attr(
    "data-value",
  );
  var defaultBladeSize = "46";
  if (getBladeSize == "60") {
    $(".filter-blade-size").attr("data-value", defaultBladeSize);
    $(".blade-size-selector .filter-item.bsize" + defaultBladeSize).addClass(
      "active",
    );
    $(".blade-size-selector .filter-item.bsize6").removeClass("active");
    $(".blade-size-selector p .filter-blade-size").text(defaultBladeSize + '"');
  }
}
function initialImages() {
  var currentFanType = $(".current-main-listing .filter-fan-type").attr(
    "data-value",
  );
  $(".fan-type-selector li." + currentFanType).click();

  var SmartOverlay = $("ul.filter.oasis-select .smart").attr("data-fan-image");
  var StandardOverlay = $("ul.filter.oasis-select .standard").attr(
    "data-fan-image",
  );
  $(".product-single__thumbnail .smart-fan").attr("src", SmartOverlay);
  $(".product-single__thumbnail .standard-fan").attr("src", StandardOverlay);
}
/*
function collectionSelection() {
  /* set initial variants when selected from the collection page 

  var urlString = document.referrer;
  var variantSelected = localStorage.getItem("prodType");
  console.log(urlString);
  if (urlString.indexOf("prismplus") > -1) {
    /* if inside prism 
    if (urlString.indexOf("variant") > -1) {
      /* if has variant, this means that there was a selection done between hugger or downrod 
      /* if there was a selection, the localStorage got updated 
      var motorString = variantSelected;
      var paramString =
        urlString.split("?")[0]; /* split the variant part to remove
      console.log(motorString);
    } else {
      /* if there is no selection, the localStorage is not updated so use the default 'hugger' as the selection 
      var motorString = "hugger";
      var paramString = urlString;
    }
    var bladeString = paramString.split("/products/")[1].replace("-blade", "");
    console.log('hello:'+variantSelected);
    if (bladeString == "curved") {
      /* since collection title uses curved, remove the d since 'curve' is the one used for selections 
      bladeString = "curve";
    } else if (bladeString == "wing-tip") {
      bladeString = "wing-tip";
    } else if ((bladeString = "leaf")) {
      bladeString = "leaf";
    } else {
      bladeString = "curve";
    }
    $(".blade-type-selector  p .filter-blade-type ").text(
      bladeString.replace("-", " ")
    );
    $(".filter-blade-type").attr("data-value", bladeString.toLowerCase());

    $(".filter-motor-type").attr(
      "data-value",
      motorString
    );
    $(".motor-type-selector  p .filter-motor-type ").text(motorString);
  } //outside prism, do nothing
}*/
jQuery(document).ready(function ($) {
  /* other functionalities here */

  /* change rgb text to rgb + cct */
  $(".filter-item.item.nrgb").text("RGB + CCT");

  /* size modal - added it here since orig popup modals are a little too crowded already */
  $(".v2-size-modal").click(function () {
    $(".oasisv2-size-modal").addClass("active");
    $(".stockclose").addClass("show bgshow");
  });
  $(".v2-smart-modal").click(function () {
    $(".oasisv2-smart-modal").addClass("active");
    $(".stockclose").addClass("show bgshow");
  });

  /* product slice rgb/cct - toggleswitch & content */
  $(".togglelight .switch li").click(function () {
    var clickedType = $(this).attr("data-type");
    console.log(clickedType);
    $(".togglelight .s-item, .overlaybg").removeClass("active");
    $(".togglelight .s-item." + clickedType).addClass("active");
    $(".overlaybg." + clickedType + "-light").addClass("active");
    $($(this)).addClass("active");
  });

  $(".toggleremote .switch li").click(function () {
    var clickedType = $(this).attr("data-type");
    //console.log(clickedType);
    $(
      ".toggleremote .s-item, .toggleremote .image-wrap, .toggleremote .text-item",
    ).removeClass("active");
    $(".toggleremote .text-item." + clickedType).addClass("active");
    $(".toggleremote .image-wrap." + clickedType).addClass("active");
    $($(this)).addClass("active");
  });
});
/*
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
*/

function setDisclaimers() {
  /* get list from disclaimer list div */
  /* get current selection */
  /* if current selection contains from the list, display disclaimer */
}
